import { GetterTree } from "vuex";
import { AppState, AppView, FeatureSettings, LayoutType, ToastData, UserRole } from "./state";
import { defineVuexName, MODULES } from "../utils";

const getters: GetterTree<AppState, any> = {
  appLayout(state: AppState): LayoutType {
    return state.layout;
  },
  appView(state: AppState): AppView {
    return state.appView;
  },
  //appView
  [defineVuexName(MODULES.APP.GETTERS.GET_APP_VIEW)](state: AppState): AppView {
    return state.appView;
  },
  appToast(state: AppState): ToastData {
    return state.toast;
  },
  //appToast
  [defineVuexName(MODULES.APP.GETTERS.GET_APP_TOAST)](state: AppState): ToastData {
    return state.toast;
  },
  cameraDeviceId(state: AppState): string {
    return state.cameraDeviceId;
  },
  //cameraDeviceId
  [defineVuexName(MODULES.APP.GETTERS.GET_CAMERA_DEVICE_ID)](state: AppState): string {
    return state.cameraDeviceId;
  },
  microphoneDeviceId(state: AppState): string {
    return state.microphoneDeviceId;
  },
  //microphoneDeviceId
  [defineVuexName(MODULES.APP.GETTERS.GET_MICROPHONE_DEVICE_ID)](state: AppState): string {
    return state.microphoneDeviceId;
  },
  speakerDeviceId(state: AppState): string {
    return state.speakerDeviceId;
  },
  //speakerDeviceId
  [defineVuexName(MODULES.APP.GETTERS.GET_SPEAKER_DEVICE_ID)](state: AppState): string {
    return state.speakerDeviceId;
  },
  userRole(state: AppState): UserRole {
    return state.userRole;
  },
  //userRole
  [defineVuexName(MODULES.APP.GETTERS.GET_USER_ROLE)](state: AppState): UserRole {
    return state.userRole;
  },
  getLowBandWidth(state: AppState): boolean {
    return state.isLowBandWidth;
  },
  //getLowBandWidth
  [defineVuexName(MODULES.APP.GETTERS.GET_LOW_BAND_WIDTH)](state: AppState): boolean {
    return state.isLowBandWidth;
  },
  getReplacedClassId(state: AppState): string {
    return state.replacedClassId;
  },
  //getReplacedClassId
  [defineVuexName(MODULES.APP.GETTERS.GET_REPLACED_CLASS_ID)](state: AppState): string {
    return state.replacedClassId;
  },
  havePermissionCamera(state: AppState) {
    return state.havePermissionCamera;
  },
  //havePermissionCamera
  [defineVuexName(MODULES.APP.GETTERS.GET_HAVE_PERMISSION_CAMERA)](state: AppState) {
    return state.havePermissionCamera;
  },
  havePermissionMicrophone(state: AppState) {
    return state.havePermissionMicrophone;
  },
  //havePermissionMicrophone
  [defineVuexName(MODULES.APP.GETTERS.GET_HAVE_PERMISSION_MICROPHONE)](state: AppState) {
    return state.havePermissionMicrophone;
  },
  havePermissionSpeaker(state: AppState) {
    return state.havePermissionSpeaker;
  },
  //havePermissionSpeaker
  [defineVuexName(MODULES.APP.GETTERS.GET_HAVE_PERMISSION_SPEAKER)](state: AppState) {
    return state.havePermissionSpeaker;
  },
  getEnabledFeatures(state: AppState): string[] {
    return state.enabledFeatures;
  },
  isDynamicVideoAdjusterEnabled(state: AppState): boolean {
    return state.enabledFeatures.includes(FeatureSettings.DynamicVideoAdjuster);
  },
  isHideClassmateVideosOnLowBandwidthEnabled(state: AppState): boolean {
    return state.enabledFeatures.includes(FeatureSettings.DynamicVideoAdjuster) && state.isLowBandWidthDueToDownlink;
  },
};

export default getters;
